<template>
  <div id="slide">
    <v-img :src="'/img/slider/3a.png'" width="100%" class="grey lighten-2">
        <div class="slide-frame">
            <!-- <h3 class="hidden-sm-and-down"> {{ title_RU }} </h3> -->
            <p class="font-weight-bold subheading">{{ regalii_RU }}</p>
            <h2 class="hidden-sm-and-down">З преси:</h2>
            <p class="hidden-sm-and-down subheading font-italic">{{ text_RU }}</p>
        </div>
      </v-img>
    <div class="slide-footer text-xs-center hidden-sm-and-down"></div>
  </div>
</template>

<script>
  export default {
    name: "slide",
    data () {
      return {
        title_RU: 'Ірина Семененко',
        regalii_RU: 'Сопрано, заслужена артистка України, солістка Національної опери України, лауреат українських та міжнародних конкурсів, доцент кафедри оперного співу Національної музичної академії України ім. П. І. Чайковського',
        text_RU: '"Чарівний вокал Ірини Семененко, елегантне оформлення – все продумано, відібрано та відрепетировано до дрібниць. При цьому впродовж трьох відділень концерту глядачів не залишає відчуття сиюсекундної творчості, натхненної імпровізації..."', 
        subtext_RU: 'Сопрано, заслужена артистка України, солістка Національної опери України, лауреат українських та міжнародних конкурсів, доцент кафедри оперного співу Національної музичної академії України ім. П. І. Чайковського.' 
      }
    }
  }
</script>

<style>
      .slide-frame {
        margin-top: 60px;
        max-width: 650px;
        background-color: rgba(0,0,0,0.7);
        color:rgb(160, 158, 158);  
        padding: 30px 0 0 30px;
      }
      #slide h2 {
          color:rgb(134, 133, 133);
          margin: 50px 0 10px 40px;
          font-size: 30px!important;
          font-family: 'Open Sans Condensed', sans-serif!important;
      }
      #slide h3 {
        font-family: 'CassandraRegular', sans-serif!important;
        font-size: 50px!important;
        color: rgb(160, 158, 158);
        font-weight: 700; 
      }
      .slide-frame p {
        max-width: 700px;
        text-align: justify;
        font-family: 'Open Sans Condensed', sans-serif!important;
        font-size: 20px!important;
        /* color: rgb(160, 158, 158);  */

        padding-right: 10px;
      }
      .slide-footer {
        padding-top: 10px;
        background-color: #000;
        height: 100px;
        font-family:'CassandraRegular', sans-serif;
        font-size:24px;
        color:rgb(187, 185, 185);
        font-weight:500;
      }
      @media only screen and (max-width: 992px) {
          .slide-frame {
              max-width: 500px;
          }
      }

      /* TABLETS */
      @media only screen and (max-width: 768px) {
          #slide h2 {
            font-size: 18px!important;
            margin:0 0 10px 40px;
           }
          #slide h3 {
            font-size: 30px!important;
            margin: auto;
          }
          .slide-frame {
              max-width: 400px;
              margin-top: 30px;
          }   
          .slide-frame p {
            font-size: 16px!important;
          }
      }

      /* PHONES */
      @media only screen and (max-width: 600px) {
          #slide h2 {
            font-size: 18px!important;
            margin:0 0 10px 40px;
           }
          #slide h3 {
            font-size: 30px!important;
            margin: auto;
          }
          .slide-frame {
              max-width: 240px;
              margin-top: 0;
          }   
          .slide-frame p {
            font-size: 14px!important;
          }   
      }
</style>

